import { ACTION_SUBJECT_PREFIX } from '../../constants/analytics';
import { type ProductKeys } from '../../constants/products';
import { type FireAnalyticsEvent } from '../../types';

import { type CommonAttributes, type NonPrivacySafeAttributes } from './types';

type AppFilterShowHideClickedArgs = {
	commonAttributes: CommonAttributes;
	nonPrivacySafeAttributes: NonPrivacySafeAttributes;
	productKey: ProductKeys;
	hidden: boolean;
	isConnected: boolean;
};

export const onAppFilterShowHideClicked = ({
	commonAttributes,
	nonPrivacySafeAttributes,
	productKey,
	hidden,
	isConnected,
}: AppFilterShowHideClickedArgs): FireAnalyticsEvent => ({
	eventType: 'ui',
	actionSubject: 'button',
	actionSubjectId: `${ACTION_SUBJECT_PREFIX}RightPanelAppFilterMenuButton`,
	action: 'clicked',
	attributes: {
		additionalAttributes: {
			productKey,
			hidden,
			isConnected,
		},
		commonAttributes,
	},
	nonPrivacySafeAttributes,
});
